module.exports = __webpack_public_path__ + "img/pos5_banner.b482c35b.png";